import { Form, Modal, Row, Col, Spinner } from "react-bootstrap";
import "./AddEditRoleMaster.css"

const ViewCustomerMaster = (props) => {
    const customerObj = props.rowdata;

    return (
        <>
            {/* {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>} */}
            <Modal
                {...props}
                size="lg"
                backdrop="static" centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {props.action} Customer
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        id="customermaster"
                        name="customermaster"
                    >
                        <Row >
                            <Col md={4} xs={12}>
                                <Form.Group className="g-input ">
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            id="CustomerCode"
                                            type="text"
                                            name="CustomerCode"
                                            value={customerObj.CustomerCode}
                                            readOnly />
                                        <Form.Label className="frm-label" for="CustomerCode">BP Code</Form.Label>
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="CustomerName"
                                        type="text"
                                        name="CustomerName"
                                        value={customerObj.CustomerName}
                                        readOnly
                                    />
                                    <Form.Label className="frm-label" for="CustomerName">BP Name</Form.Label>
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="Address"
                                        type="text"
                                        name="Address"
                                        value={customerObj.Address}
                                        readOnly
                                    />
                                    <Form.Label className="frm-label" htmlFor="Address">Address</Form.Label>
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="PinCode"
                                        type="text"
                                        name="PinCode"
                                        value={customerObj.PinCode}
                                        readOnly
                                    />
                                    <Form.Label className="frm-label" htmlFor="PinCode">Zip Code/ Postal Code</Form.Label>
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="City"
                                        type="text"
                                        name="City"
                                        value={customerObj.City}
                                        readOnly
                                    />
                                    <Form.Label className="frm-label" htmlFor="City">City</Form.Label>
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            id="EmailId"
                                            type="text"
                                            name="EmailId"
                                            value={customerObj.EmailId}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label" for="EmailId">Email</Form.Label>
                                    </div>
                                </Form.Group>
                            </Col>

                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ViewCustomerMaster;
